var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Field } from 'react-redux-form';
import { connect } from 'react-redux';

import Tip from "../../Layout/Tip";
import PropertyConfigOption from "./PropertyConfigOption";
import { Translate } from "../../I18N";
import PrioritySortingLabel from "./PrioritySortingLabel";

export class FormConfigCommon extends Component {
  getZeroIndex() {
    const { index, data } = this.props;
    const baseZeroIndex = index + data.commonProperties.length;
    return baseZeroIndex;
  }

  renderTitleField() {
    const { index, formState } = this.props;
    let labelClass = 'form-group';
    const labelKey = `commonProperties.${this.getZeroIndex()}.label`;
    const requiredLabel = formState.$form.errors[`${labelKey}.required`];
    const duplicatedLabel = formState.$form.errors[`${labelKey}.duplicated`];
    if (requiredLabel || duplicatedLabel) {
      labelClass += ' has-error';
    }

    return /*#__PURE__*/(
      _jsx("div", { className: labelClass }, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: `label${index}` }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Name")
      ), /*#__PURE__*/
      _jsx(Field, { model: `template.data.commonProperties[${this.getZeroIndex()}].label` }, void 0, /*#__PURE__*/
      _jsx("input", { id: `label${index}`, className: "form-control" })
      )
      ));

  }

  render() {
    const { index, data } = this.props;
    const property = data.commonProperties[this.getZeroIndex()];

    return /*#__PURE__*/(
      _jsx("div", {}, void 0,
      property.name === 'title' && this.renderTitleField(), /*#__PURE__*/
      _jsx(Field, { model: `template.data.commonProperties[${this.getZeroIndex()}].prioritySorting` }, void 0, /*#__PURE__*/
      _jsx("input", { id: `prioritySorting${index}`, type: "checkbox" }), "\xA0", /*#__PURE__*/

      _jsx(PrioritySortingLabel, { htmlFor: `prioritySorting${index}` })
      ),
      property.name === 'title' && /*#__PURE__*/
      _jsx(PropertyConfigOption, {
        label: "Generated ID",
        model: `template.data.commonProperties[${this.getZeroIndex()}].generatedId` }, void 0, /*#__PURE__*/

      _jsx(Tip, {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "A generated ID will be the default title.")
      )
      )

      ));

  }
}







export function mapStateToProps({ template }) {
  return {
    data: template.data,
    formState: template.formState
  };
}

export default connect(mapStateToProps)(FormConfigCommon);